import React from 'react'
import cx from 'classnames'

import { Href } from 'components/navigation'
import { Text } from 'components/dataDisplay'

import s from './EventCard.scss'


const EventCard = (props) => {
  const { className, style, title, bookmarked, start, end, type, image, to, handleBookmarkClick } = props

  return (
    <Href className={cx(className, s.root, 'flex flex-col')} to={to}>
      <div className={cx('relative radius-16 overflow-hidden')} style={style}>
        <div
          className={cx('radius-8 object-fill')}
          style={{ backgroundImage: `url(${image})`, backgroundSize: 'cover', width: '100%', height: '183px', filter: 'blur(10px)' }}
        />
        <div
          className={cx(s.image, 'w-full absolute')}
          style={{
            top: '0',
            left: '0',
            width: '100%',
            height: '183px',
            backgroundImage: `url(${image})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center center',
          }}
        />
        <div className={cx(s.tag, 'absolute py-4px px-12px radius-16')}>{type}</div>
        {/* <Href className={cx(s.bookmarkWrapper, 'absolute')} onClick={handleBookmarkClick} />
        <Icon
          className={cx(s.icon, 'absolute')}
          name={bookmarked ? 'action/favorites-active_20' : 'action/favorite-add_20'}
          color="amelie"
        /> */}
      </div>
      <Text
        className={cx(s.title, 'mt-16px')}
        message={title}
        size="h16-20"
      />
      <Text
        className={cx(s.date, 'mt-4px opacity-48')}
        message={`${start}${end ? `-${end}` : ''}`}
        size="s13-r"
      />
    </Href>
  )
}

export default EventCard